import React, { useCallback, useMemo, useState } from 'react';
import { FiSearch, FiTag } from 'react-icons/fi';
import Tooltip from '../../layout/ReusableComponent/Tooltip/Tooltip';
import { useStorageBox } from '../StorageBoxContext';
import StorageBoxSidebarSection, {
  readSidebarSectionExpanded,
  writeSidebarSectionExpanded,
} from './StorageBoxSidebarSection';
import { useStorageBoxSidebarDrawer } from '../StorageBoxSidebarDrawerContext';

const SECTION_KEY = 'sb-sidebar-labels-expanded';
export default function StorageBoxSidebarLabels() {
  const {
    readOnly,
    userLabels,
    browseMode,
    activeLabel,
    openLabelView,
    vaultScope,
    lockVaultAccessActive,
  } = useStorageBox();
  const inLockRealm = vaultScope === 'lock';
  const lockUnlocked = lockVaultAccessActive;
  const [expanded, setExpanded] = useState(() => readSidebarSectionExpanded(SECTION_KEY, false));
  const [labelQuery, setLabelQuery] = useState('');
  const closeDrawer = useStorageBoxSidebarDrawer();

  const toggleExpanded = useCallback(() => {
    setExpanded((v) => {
      const next = !v;
      writeSidebarSectionExpanded(SECTION_KEY, next);
      return next;
    });
  }, []);

  const filteredLabels = useMemo(() => {
    const q = labelQuery.trim().toLowerCase();
    if (!q) return userLabels;
    return userLabels.filter((label) => label.toLowerCase().includes(q));
  }, [userLabels, labelQuery]);

  if (readOnly) return null;
  if (inLockRealm && !lockUnlocked) return null;

  const showLabelSearch = expanded && userLabels.length > 0;

  return (
    <StorageBoxSidebarSection
      title={inLockRealm ? 'Lock labels' : 'Labels'}
      expanded={expanded}
      onToggle={toggleExpanded}
      className="sb-drive-labels-nav"
    >
      {showLabelSearch ? (
        <div className="sb-drive-labels-nav__search-wrap">
          <FiSearch className="sb-drive-labels-nav__search-icon" aria-hidden />
          <input
            type="search"
            className="sb-drive-labels-nav__search"
            placeholder="Search labels"
            value={labelQuery}
            onChange={(e) => setLabelQuery(e.target.value)}
            aria-label="Search labels"
          />
        </div>
      ) : null}
      {userLabels.length ? (
        filteredLabels.length ? (
          <ul className="sb-drive-labels-nav__list">
            {filteredLabels.map((label) => {
              const active = browseMode === 'label' && activeLabel === label;
              return (
                <li key={label}>
                  <Tooltip text={label} position="right" className="sb-drive-labels-nav__tooltip-wrap">
                    <button
                      type="button"
                      className={`sb-drive-nav-item sb-drive-nav-item--label${active ? ' sb-drive-nav-item--active' : ''}`}
                      onClick={() => {
                        openLabelView(label);
                        closeDrawer();
                      }}
                    >
                      <FiTag aria-hidden />
                      <span className="sb-drive-nav-item__label sb-drive-nav-item__label--truncate">{label}</span>
                    </button>
                  </Tooltip>
                </li>
              );
            })}
          </ul>
        ) : (
          <p className="sb-drive-labels-nav__empty">No labels match your search.</p>
        )
      ) : (
        <p className="sb-drive-labels-nav__empty">Add labels from an item&apos;s details panel.</p>
      )}
    </StorageBoxSidebarSection>
  );
}
